import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import { Formik } from "formik";
import {
  Alert,
  Autocomplete,
  Avatar,
  CircularProgress,
  createTheme,
  Divider,
  FormHelperText,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import {
  useEditKeyNcrMutation,
  useGetKeyNcrQuery,
} from "store/slices/apis/keyNcrSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const currentStatuses = [
  { label: "Open", year: 1994 },
  { label: "Close", year: 1972 },
];

export default function EditNcr(props) {
  const {
    open,
    cancelIssue,
    openNotification,
    data,
    isViewIssueModal,
    refetch,
  } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [file, setFile] = useState(null);
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const { data: ncrDetail, isSuccess: issueDetailSuccess } = useGetKeyNcrQuery(
    data?.id
  );

  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();
  const [getSubPackage2, { data: subPackageList2 }] = useLazyGetPackagesQuery();
  // const [getSubPackage3, { data: subPackageList3 }] = useLazyGetPackagesQuery();
  // const [getSubPackage4, { data: subPackageList4 }] = useLazyGetPackagesQuery();
  // const [getSubPackage5, { data: subPackageList5 }] = useLazyGetPackagesQuery();
  // const [getSubPackage6, { data: subPackageList6 }] = useLazyGetPackagesQuery();
  // const [getSubPackage7, { data: subPackageList7 }] = useLazyGetPackagesQuery();

  const [editKeyNcr, { isLoading }] = useEditKeyNcrMutation();

  const [formData, setFormData] = useState({
    contractor: "",
    package: "",
    subPackage1: "",
    subPackage2: "",
    // subPackage3: "",
    // subPackage4: "",
    // subPackage5: "",
    // subPackage6: "",
    // subPackage7: "",
    DateOfIssueOfNCR: "",
    NonConformanceDescription: "",
    NCRRaisedBy: "",
    actionRequiredBy: "",
    actionRequiredByEmail: "",
    PlannedDateOfCorrectiveActionCompeltion: "",
    ActualExpectedDateOfCorrectiveActionCompeltion: "",
    PlannedDateOfNCRClose: "",
    ActualExpectedDateOfNCRClose: "",
    currentStatus: "",
    projectId,
  });

  // Fetch data when modal loads
  useEffect(() => {
    getSubPackage1({ projectId: projectId, type: "subPackage1" });
    getSubPackage2({ projectId: projectId, type: "subPackage2" });
    // getSubPackage3({ projectId: projectId, type: "subPackage3" });
    // getSubPackage4({ projectId: projectId, type: "subPackage4" });
    // getSubPackage5({ projectId: projectId, type: "subPackage5" });
    // getSubPackage6({ projectId: projectId, type: "subPackage6" });
    // getSubPackage7({ projectId: projectId, type: "subPackage7" });
  }, [open]); // Runs once when modal mounts

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  useEffect(() => {
    if (issueDetailSuccess) {
      setFormData({
        contractor: data?.contractor || "",
        package: data?.package || "",
        subPackage1: data?.subPackage1 || "",
        subPackage2: data?.subPackage2 || "",
        // subPackage3: data?.subPackage3 || "",
        // subPackage4: data?.subPackage4 || "",
        // subPackage5: data?.subPackage5 || "",
        // subPackage6: data?.subPackage6 || "",
        // subPackage7: data?.subPackage7 || "",
        currentStatus: data?.currentStatus || "",
        DateOfIssueOfNCR: data?.dateOfIssueOfNCR || "",
        NonConformanceDescription: data?.nonConformanceDescription || "",
        NCRRaisedBy: data?.ncrRaisedBy || "",
        actionRequiredBy: data?.actionRequiredBy || "",
        actionRequiredByEmail: data?.actionRequiredByEmail || "",
        PlannedDateOfCorrectiveActionCompeltion:
          data?.plannedDateOfCorrectiveActionCompeltion || "",
        ActualExpectedDateOfCorrectiveActionCompeltion:
          data?.actualExpectedDateOfCorrectiveActionCompeltion || "",
        PlannedDateOfNCRClose: data?.plannedDateOfNCRClose || "",
        ActualExpectedDateOfNCRClose: data?.actualExpectedDateOfNCRClose || "",
      });
    }
  }, [issueDetailSuccess]);
  const handleClose = () => {
    // setOpen(false);
  };

  // const handleMaxWidthChange = (event) => {
  //     setMaxWidth(
  //         // @ts-expect-error autofill of arbitrary value is not handled.
  //         event.target.value,
  //     );
  // };

  // const handleFullWidthChange = (event) => {
  //     setFullWidth(event.target.checked);
  // };

  const validationSchema = Yup.object({
    // contractor: Yup.string().required("Contractor field is required."),
    package: Yup.string().required("Category field is required."),
    subPackage1: Yup.string().required("Sub Category 1 field is required."),
    subPackage2: Yup.string().required("Sub Category 2 field is required."),
    // subPackage3: Yup.string().required("Sub Category 3 field is required."),
    // subPackage4: Yup.string().required("Sub Category 4 field is required."),
    // subPackage5: Yup.string().required("Sub Category 5 field is required."),
    // subPackage6: Yup.string().required("Sub Category 6 field is required."),
    // subPackage7: Yup.string().required("Sub Category 7 field is required."),
    DateOfIssueOfNCR: Yup.date()
      .required("Date of Issue of NCR is required.")
      .nullable()
      .typeError("Date of Issue of NCR must be a valid date."),
    NonConformanceDescription: Yup.string().required(
      "Non Conformance Description is required."
    ),
    NCRRaisedBy: Yup.string().required("NCR Raised By field is required."),
    actionRequiredBy: Yup.string().required(
      "Action required by field is required."
    ),
    actionRequiredByEmail: Yup.string()
      .email()
      .required("Action required by Email field is required."),
    PlannedDateOfCorrectiveActionCompeltion: Yup.date()
      .required("Planned Date of Corrective Action Completion is required.")
      .nullable()
      .typeError(
        "Planned Date of Corrective Action Completion must be a valid date."
      ),
    ActualExpectedDateOfCorrectiveActionCompeltion: Yup.date()
      .required(
        "Actual/Expected Date of Corrective Action Completion is required."
      )
      .nullable()
      .typeError(
        "Actual/Expected Date of Corrective Action Completion must be a valid date."
      ),
    PlannedDateOfNCRClose: Yup.date()
      .required("Planned Date of NCR Close is required.")
      .nullable()
      .typeError("Planned Date of NCR Close must be a valid date."),
    ActualExpectedDateOfNCRClose: Yup.date()
      .required("Actual/Expected Date of NCR Close is required.")
      .nullable()
      .typeError("Actual/Expected Date of NCR Close must be a valid date."),
    currentStatus: Yup.string().required("Current Status field is required."),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    setFile(acceptedFiles);
  };

  const handleRemoveFile = (index) => {
    setFile((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let reqBody = {
      contractor: values.contractor,
      package: values.package,
      subPackage1: values.subPackage1,
      subPackage2: values.subPackage2,
      // subPackage3: values.subPackage3,
      // subPackage4: values.subPackage4,
      // subPackage5: values.subPackage5,
      // subPackage6: values.subPackage6,
      // subPackage7: values.subPackage7,
      DateOfIssueOfNCR:
        values?.DateOfIssueOfNCR && dayjs(values.DateOfIssueOfNCR).isValid()
          ? dayjs(values.DateOfIssueOfNCR).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      NonConformanceDescription: values.NonConformanceDescription,
      NCRRaisedBy: values.NCRRaisedBy,
      actionRequiredBy: values.actionRequiredBy,
      actionRequiredByEmail: values.actionRequiredByEmail,
      PlannedDateOfCorrectiveActionCompeltion:
        values?.PlannedDateOfCorrectiveActionCompeltion &&
          dayjs(values.PlannedDateOfCorrectiveActionCompeltion).isValid()
          ? dayjs(values.PlannedDateOfCorrectiveActionCompeltion).format(
            "YYYY-MM-DD"
          ) + "T00:00:00.000Z"
          : null,
      ActualExpectedDateOfCorrectiveActionCompeltion:
        values?.ActualExpectedDateOfCorrectiveActionCompeltion &&
          dayjs(values.ActualExpectedDateOfCorrectiveActionCompeltion).isValid()
          ? dayjs(values.ActualExpectedDateOfCorrectiveActionCompeltion).format(
            "YYYY-MM-DD"
          ) + "T00:00:00.000Z"
          : null,
      PlannedDateOfNCRClose:
        values?.PlannedDateOfNCRClose &&
          dayjs(values.PlannedDateOfNCRClose).isValid()
          ? dayjs(values.PlannedDateOfNCRClose).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      ActualExpectedDateOfNCRClose:
        values?.ActualExpectedDateOfNCRClose &&
          dayjs(values.ActualExpectedDateOfNCRClose).isValid()
          ? dayjs(values.ActualExpectedDateOfNCRClose).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      currentStatus: values.currentStatus,
      workflowApprovalId: data?.workflowApprovalId,
      projectId
    };

    try {
      const formData = new FormData();
      formData.append(
        "ncrJson",
        JSON.stringify({ ...reqBody, id: data?.id, NcrNumber: data?.ncrNumber })
      );
      if (file != null) {
        formData.append("file", file[0]);
      }

      const response = await editKeyNcr({
        id: data?.id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(response?.message, "success");
        setFile(null);
        refetch();
        cancelIssue();
      } else {
        openNotification(response?.message);
      }
    } catch (error) {
      openNotification(error?.error, "error");
    } finally {
      setSubmitting(false);
    }
  };

   const CustomCalendarIcon = (props) => (
      <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
    );

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          {isViewIssueModal ? "View" : "Edit"} Quality
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          Select Categories
                        </Typography>
                      </Grid2>

                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Autocomplete
                          options={packages?.data}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option}
                          value={
                            packages?.data?.find(
                              (option) => option === values.package
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setFieldValue(
                              "package",
                              newValue ? newValue : ""
                            );
                            setFieldValue("subPackage1", "");
                            setFieldValue("subPackage2", "");
                            // setFieldValue("subPackage3", "");
                            // setFieldValue("subPackage4", "");
                            // setFieldValue("subPackage5", "");
                            // setFieldValue("subPackage6", "");
                            // setFieldValue("subPackage7", "");
                          }}
                          onBlur={() =>
                            setTouched({ ...touched, package: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Category"
                              name="package"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.package && errors?.package && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.package}`}</FormHelperText>
                        )}
                      </Grid2>
                      {values?.package && (
                        <Grid2 size={{ xs: 12, md: 6 }}>
                          <Autocomplete
                            options={subPackageList1?.data}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList1?.data?.find(
                                (option) =>
                                  option === values?.subPackage1
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage1",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage2", "");
                              // setFieldValue("subPackage3", "");
                              // setFieldValue("subPackage4", "");
                              // setFieldValue("subPackage5", "");
                              // setFieldValue("subPackage6", "");
                              // setFieldValue("subPackage7", "");
                              // getSubPackage2({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage2' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage1: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 1"
                                name="subPackage1"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage1 && errors?.subPackage1 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage1}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {values?.subPackage1 && (
                        <Grid2 size={{ xs: 12, md: 6 }}>
                          <Autocomplete
                            options={subPackageList2?.data}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList2?.data?.find(
                                (option) =>
                                  option === values?.subPackage2
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage2",
                                newValue ? newValue : ""
                              );
                              // setFieldValue("subPackage3", "");
                              // setFieldValue("subPackage4", "");
                              // setFieldValue("subPackage5", "");
                              // setFieldValue("subPackage6", "");
                              // setFieldValue("subPackage7", "");
                              // getSubPackage3({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage3' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage2: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 2"
                                name="subPackage2"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage2 && errors?.subPackage2 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage2}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {/* {values?.subPackage2 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList3?.data || [])?.filter(
                              (option) => option
                            )}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList3?.data?.find(
                                (option) =>
                                  option === values?.subPackage3
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage3",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage4", "");
                              setFieldValue("subPackage5", "");
                              setFieldValue("subPackage6", "");
                              setFieldValue("subPackage7", "");
                              // getSubPackage4({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage4' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage3: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 3"
                                name="subPackage3"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage3 && errors?.subPackage3 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage3}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {values?.subPackage3 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList4?.data || [])?.filter(
                              (option) => option
                            )}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList4?.data?.find(
                                (option) =>
                                  option === values?.subPackage4
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage4",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage5", "");
                              setFieldValue("subPackage6", "");
                              setFieldValue("subPackage7", "");
                              // getSubPackage5({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage5' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage4: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 4"
                                name="subPackage4"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage4 && errors?.subPackage4 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage4}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}

                      {values?.subPackage4 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList5?.data || [])?.filter(
                              (option) => option
                            )}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList5?.data?.find(
                                (option) =>
                                  option === values?.subPackage5
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage5",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage6", "");
                              setFieldValue("subPackage7", "");
                              // getSubPackage6({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage6' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage5: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 5"
                                name="subPackage5"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage5 && errors?.subPackage5 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage5}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}

                      {values?.subPackage5 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList6?.data || [])?.filter(
                              (option) => option
                            )}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList6?.data?.find(
                                (option) =>
                                  option === values?.subPackage6
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage6",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage7", "");
                              // getSubPackage7({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage7' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage6: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 6"
                                name="subPackage6"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage6 && errors?.subPackage6 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage6}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}

                      {values?.subPackage6 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList7?.data || [])?.filter(
                              (option) => option
                            )}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList7?.data?.find(
                                (option) =>
                                  option === values?.subPackage7
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage7",
                                newValue ? newValue : ""
                              );
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage7: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 7"
                                name="subPackage7"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage7 && errors?.subPackage7 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage7}`}</FormHelperText>
                          )}
                        </Grid2>
                      )} */}
                    </Grid2>
                    <Divider
                      sx={{
                        width: "100%",
                        mb: 2,
                        mt: 2,
                        borderBottomWidth: "medium",
                      }}
                    />
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          Enter Quality Details
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Autocomplete
                          options={contractors?.data}
                          getOptionLabel={(option) => option.name}
                          disabled={isViewIssueModal}
                          value={
                            contractors?.data.find(
                              (option) => option.id === values.contractor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "contractor",
                              newValue ? newValue.id : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, contractor: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Consultant/Contractor"
                              name="contractor"
                              // error={touched.contractor && Boolean(errors.contractor)}
                              // helperText={touched.contractor && errors.contractor}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.contractor && errors?.contractor && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.contractor}`}</FormHelperText>
                        )}
                      </Grid2>

                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Date Of Issue Of NCR"
                            value={
                              values?.DateOfIssueOfNCR
                                ? dayjs(values.DateOfIssueOfNCR)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "DateOfIssueOfNCR",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                             slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, DateOfIssueOfNCR: true })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 13, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 14,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.DateOfIssueOfNCR &&
                            errors?.DateOfIssueOfNCR && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.DateOfIssueOfNCR}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <TextField
                          id="outlined-multiline-staticrequired_by_email"
                          label="NCR Raised By"
                          name="NCRRaisedBy"
                          fullWidth
                          value={values?.NCRRaisedBy}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              NCRRaisedBy: true,
                            })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.NCRRaisedBy && errors?.NCRRaisedBy && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.NCRRaisedBy}`}</FormHelperText>
                        )}
                      </Grid2>

                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <TextField
                          id="outlined-multiline-staticrequired_by"
                          label="Action Required By"
                          name="actionRequiredBy"
                          fullWidth
                          value={values?.actionRequiredBy}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, actionRequiredBy: true })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.actionRequiredBy &&
                          errors?.actionRequiredBy && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.actionRequiredBy}`}</FormHelperText>
                          )}
                      </Grid2>

                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <TextField
                          id="outlined-multiline-staticrequired_by_email"
                          label="Action Required By Email"
                          name="actionRequiredByEmail"
                          fullWidth
                          value={values?.actionRequiredByEmail}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              actionRequiredByEmail: true,
                            })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.actionRequiredByEmail &&
                          errors?.actionRequiredByEmail && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.actionRequiredByEmail}`}</FormHelperText>
                          )}
                      </Grid2>

                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Planned Date Of Corrective Action Compeltion"
                            value={
                              values?.PlannedDateOfCorrectiveActionCompeltion
                                ? dayjs(
                                  values.PlannedDateOfCorrectiveActionCompeltion
                                )
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "PlannedDateOfCorrectiveActionCompeltion",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                             slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                PlannedDateOfCorrectiveActionCompeltion: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 13, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 14,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.PlannedDateOfCorrectiveActionCompeltion &&
                            errors?.PlannedDateOfCorrectiveActionCompeltion && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.PlannedDateOfCorrectiveActionCompeltion}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Actual Date Of Corrective Action Compeltion"
                            value={
                              values?.ActualExpectedDateOfCorrectiveActionCompeltion
                                ? dayjs(
                                  values.ActualExpectedDateOfCorrectiveActionCompeltion
                                )
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "ActualExpectedDateOfCorrectiveActionCompeltion",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                             slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                ActualExpectedDateOfCorrectiveActionCompeltion: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 13, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 14,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.ActualExpectedDateOfCorrectiveActionCompeltion &&
                            errors?.ActualExpectedDateOfCorrectiveActionCompeltion && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.ActualExpectedDateOfCorrectiveActionCompeltion}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Planned Date Of NCR Close"
                            value={
                              values?.PlannedDateOfNCRClose
                                ? dayjs(values.PlannedDateOfNCRClose)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "PlannedDateOfNCRClose",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                             slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                PlannedDateOfNCRClose: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 13, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 14,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.PlannedDateOfNCRClose &&
                            errors?.PlannedDateOfNCRClose && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.PlannedDateOfNCRClose}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Actual Expected Date Of NCR Close"
                            value={
                              values?.ActualExpectedDateOfNCRClose
                                ? dayjs(values.ActualExpectedDateOfNCRClose)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "ActualExpectedDateOfNCRClose",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                             slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}  
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                ActualExpectedDateOfNCRClose: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 13, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 14,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.ActualExpectedDateOfNCRClose &&
                            errors?.ActualExpectedDateOfNCRClose && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.ActualExpectedDateOfNCRClose}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Autocomplete
                          options={currentStatuses}
                          getOptionLabel={(option) => option?.label}
                          disabled={isViewIssueModal}
                          value={
                            currentStatuses.find(
                              (option) => option.label === values?.currentStatus
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "currentStatus",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, currentStatus: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Current Status"
                              name="currentStatus"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.currentStatus && errors?.currentStatus && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.currentStatus}`}</FormHelperText>
                        )}
                      </Grid2>
                      <Grid2 size={12}>
                        <TextField
                          id="outlined-multiline-static2"
                          label="Description"
                          name="NonConformanceDescription"
                          fullWidth
                          multiline
                          value={values?.NonConformanceDescription}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              NonConformanceDescription: true,
                            })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.NonConformanceDescription &&
                          errors?.NonConformanceDescription && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.NonConformanceDescription}`}</FormHelperText>
                          )}
                      </Grid2>
                      {!isViewIssueModal && (
                        <Grid2 size={12}>
                          {file?.length > 0 ? (
                            <>
                              <List dense={dense}>
                                {file.map((file, index) => (
                                  <ListItem
                                    key={index}
                                    sx={{
                                      padding: 0,
                                    }}
                                    secondaryAction={
                                      <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() => handleRemoveFile(index)}
                                      >
                                        <RxCross2 />
                                      </IconButton>
                                    }
                                  >
                                    <ListItemAvatar>
                                      <Avatar sx={{ background: "none" }}>
                                        <FaRegFileLines
                                          fontSize="inherit"
                                          style={{ color: "#474747" }}
                                        />
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={`${file?.name}`}
                                      secondary={
                                        secondary ? "Secondary text" : null
                                      }
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            </>
                          ) : (
                            <>
                              <DragAndDropUpload onDrop={handleDrop} />
                            </>
                          )}
                        </Grid2>
                      )}

                      <Grid2 size={12}>
                        {/* <Button onClick={cancelIssue} variant='outlined' sx={{
                                                    color: `${newtheme?.customSettings?.themeColor}`, border: `1px solid ${newtheme?.customSettings?.themeColor}`, padding: '6px 20px', fontWeight: '500', textTransform: 'none', float: 'right', fontSize: '16px'
                                                }}>
                                                    Cancel
                                                </Button> */}
                        {!isViewIssueModal && (
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Edit Quality
                          </Button>
                        )}
                      </Grid2>
                    </Grid2>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
